<template>
  <v-row justify="center">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" v-if="ativo" width="500" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ this.nomeEquipe }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row style="padding-bottom: 10px" v-if="equipe.length > 0">
              <h5>Membros:</h5>
            </v-row>
            <v-row style="padding-top: 10px" v-if="equipe.length <= 0">
              <h5>Sem membros cadastrados!</h5>
            </v-row>
            <div
              style="
                align-items: center;
                display: flex;
                padding-top: 5px;
                padding-bottom: 5px;
              "
              v-for="(n, index) in equipe"
              :key="n"
            >
              <p style="width: 90%">{{ n.nomeEqui }}</p>
              <v-btn
                color="red-darken-1"
                variant="text"
                @click="chamaRemove(n, index)"
                prepend-icon="mdi-close"
              />
              <v-dialog
                v-model="dialog"
                v-if="true ? ativoConfirmacao : false"
                width="400"
                persistent  
                :scrim="0.4"
              >
                <v-card>
                  <v-card-title class="headline"> Remover Membro</v-card-title>
                  <v-card-text>
                    Você tem certeza que deseja remover este membro?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      dark
                      variant="text"
                      @click="removeUser(n, index)"
                      >Sim</v-btn
                    >
                    <v-btn
                      color="red darken-1"
                      dark
                      variant="text"
                      @click="ativoConfirmacao = !ativoConfirmacao"
                      >Não</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            variant="text"
            @click="enviarSolicitacaoParaPai"
          >
            Cancelar</v-btn
          >
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="ativoNovo = true"
            prepend-icon="mdi-plus"
          >
            Novo usuário</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-dialog
    v-model="dialog"
    v-if="true ? ativoNovo : false"
    width="400"
    persistent
  >
    <v-card>
      <v-card-title>
        <h6>Add novo membro</h6>
      </v-card-title>
      <v-card-text>
        <v-select v-model="nome" label="Nome" :items="nomes"></v-select>
        <v-select
          v-model="forma_atuacao"
          label="Forma de atuação"
          :items="tipos"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          variant="text"
          @click="ativoNovo = !ativoNovo"
          >Cancelar</v-btn
        >
        <v-btn color="blue-darken-1" variant="text" @click="addMembro"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: Array,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    ids: {
      type: Array,
      default: null,
    },
    nomeEquipe: {
      type: String,
      default: null,
    },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    dialog: true,
    idsIntern: [],
    equipeIntern: [],
    ativoNovo: false,
    tipos: ['DESENVOLVEDOR', 'SCRUM MASTER', 'PRODUCT OWNER', 'TESTADOR - QA'],
    // eslint-disable-next-line camelcase
    forma_atuacao: null,
    pessoas: [],
    nomes: [],
    nome: null,
    dataLoad: true,
    n: null,
    indice: null,
    ativoConfirmacao: false,
  }),
  created() {
    axios
      .get(API_URL + `/usuarios/habilitados`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        response.data.forEach((pessoa) => {
          this.pessoas.push(pessoa);
          this.nomes.push(pessoa.nome);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    enviarSolicitacaoParaPai() {
      this.$emit('solicitacaoFechar', { solicitacao: false });
    },
    chamaRemove(n, index) {
      this.ativoConfirmacao = !this.ativoConfirmacao;
      this.n = n;
      this.indice = index;
    },
    // eslint-disable-next-line no-unused-vars
    removeUser(n, indice) {
      console.log(this.n);
      console.log(this.indice);
      this.idsIntern = this.ids;
      this.equipeIntern = this.equipe;
      axios
        .delete(
          `${API_URL}/equipes/${this.id}/${this.idsIntern[this.indice]}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then(() => {
          this.idsIntern.splice(this.indice, 1);
          this.equipeIntern.splice(this.indice, 1);
          this.$emit('attDados', this.id);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Equipe atualizada!',
          );
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(error.response.data.message);
        });
      this.ativoConfirmacao = false;
    },
    addMembro() {
      this.idsIntern = this.ids;
      this.equipeIntern = this.equipe;
      // eslint-disable-next-line camelcase
      let forma_atuacao = this.forma_atuacao;
      console.log(this.forma_atuacao);
      // eslint-disable-next-line camelcase
      if (this.forma_atuacao == 'SCRUM MASTER') {
        forma_atuacao = 'SCRUM_MASTER'; // eslint-disable-line
        // eslint-disable-next-line camelcase
      } else if (this.forma_atuacao == 'PRODUCT OWNER') {
        // eslint-disable-line
        forma_atuacao = 'PRODUCT_OWNER'; // eslint-disable-line
      }
      const data = {
        // eslint-disable-next-line camelcase
        forma_atuacao: forma_atuacao,
        email: this.pessoas[this.nomes.indexOf(this.nome)].email,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .put(API_URL + `/equipes/${this.id}`, data, config)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Equipe atualizada!',
          );
          this.$emit('attDados', this.id);
          this.email = null;
          this.forma_atuacao = null; // eslint-disable-line
          this.ativoNovo = false;
        })
        .catch((error) => {
          /*eslint-disable*/
          this.$refs.snackbar.showErrorSnackbar(error.response.data.message);
          /* eslint-enable */
        });
    },
  },
};
</script>
